import { format } from "date-fns";
import { FileText } from "lucide-react";
import { Link } from "react-router-dom";
import { useRecentPdfs } from "../../hooks/use-dashboard-extra";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Skeleton } from "../ui/skeleton";

export function RecentPdfs(): React.ReactElement {
  const { data, isLoading } = useRecentPdfs();
  const items = data?.items ?? [];

  return (
    <Card data-testid="recent-pdfs-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold flex items-center gap-1.5">
          <FileText className="h-3.5 w-3.5 text-muted-foreground" />
          Recently Generated
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-2" data-testid="recent-pdfs-loading">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-2/3" />
          </div>
        ) : items.length === 0 ? (
          <p className="text-xs text-muted-foreground py-2 text-center" data-testid="recent-pdfs-empty">
            No certificates generated yet.
          </p>
        ) : (
          <div className="space-y-1.5" data-testid="recent-pdfs-list">
            {items.map((item) => (
              <div key={item.id} className="flex items-center justify-between text-sm gap-2">
                <Link
                  to={`/insurance/${item.insuranceId}`}
                  className="text-primary hover:underline truncate"
                  data-testid={`recent-pdf-link-${item.id}`}
                >
                  {item.address || `Record #${item.insuranceId}`}
                </Link>
                <span className="text-xs text-muted-foreground whitespace-nowrap">
                  {item.format.toUpperCase()} · {format(new Date(item.generatedAt), "dd MMM")} · {item.generatedBy}
                </span>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
